import { render, staticRenderFns } from "./c_pictrue.vue?vue&type=template&id=50d67eb3&scoped=true"
import script from "./c_pictrue.vue?vue&type=script&lang=js"
export * from "./c_pictrue.vue?vue&type=script&lang=js"
import style0 from "./c_pictrue.vue?vue&type=style&index=0&id=50d67eb3&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d67eb3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\works\\wobaiyi\\wobaiyi-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50d67eb3')) {
      api.createRecord('50d67eb3', component.options)
    } else {
      api.reload('50d67eb3', component.options)
    }
    module.hot.accept("./c_pictrue.vue?vue&type=template&id=50d67eb3&scoped=true", function () {
      api.rerender('50d67eb3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/design/components/mobileConfigRight/c_pictrue.vue"
export default component.exports